import React from 'react';
import HubupNotificationFeedCardPreview from './HubupNotificationFeedCardPreview';
import HubupNotificationFormPreview from './HubupNotificationFormPreview';
import HubupNotificationCalendarEventPreview from './HubupNotificationCalendarEventPreview';

/**
 * Aperçu temps réel — colonne droite de la modal notification / formulaire.
 */
export default function HubupNotificationLivePreviewAside({
  mode = 'notification',
  preview,
  form,
  calendarEvent,
}) {
  const isForm = mode === 'form';
  const isEvent = mode === 'event';

  if (isEvent) {
    return (
      <aside
        className="shrink-0 border-t lg:border-t-0 lg:border-l border-border bg-[#FAFBFC] dark:bg-muted/20 flex flex-col min-h-0 w-full lg:w-[min(100%,400px)] max-h-[42vh] lg:max-h-none"
        aria-label="Aperçu de l’événement calendrier"
      >
        <div className="px-4 py-3 border-b border-border/80 shrink-0">
          <p className="text-xs font-semibold text-foreground">Aperçu calendrier</p>
          <p className="text-[11px] text-muted-foreground mt-1 leading-relaxed">
            Rendu proche de l’événement proposé aux visiteurs dans l’app.
          </p>
        </div>
        <div className="flex-1 min-h-0 overflow-y-auto p-4">
          <HubupNotificationCalendarEventPreview eventDraft={calendarEvent} />
        </div>
      </aside>
    );
  }

  if (isForm) {
    return (
      <aside
        className="shrink-0 border-t lg:border-t-0 lg:border-l border-border bg-[#FAFBFC] dark:bg-muted/20 flex flex-col min-h-0 w-full lg:w-[min(100%,400px)] max-h-[42vh] lg:max-h-none"
        aria-label="Aperçu du formulaire HubUP"
      >
        <div className="px-4 py-3 border-b border-border/80 shrink-0">
          <p className="text-xs font-semibold text-foreground">Aperçu du formulaire</p>
          <p className="text-[11px] text-muted-foreground mt-1 leading-relaxed">
            Rendu proche de la page de réponse dans l’application mobile.
          </p>
        </div>
        <div className="flex-1 min-h-0 overflow-y-auto p-4">
          <HubupNotificationFormPreview form={form || { name: '', description: '', questions: [] }} />
        </div>
      </aside>
    );
  }

  if (!preview) return null;

  return (
    <aside
      className="shrink-0 border-t lg:border-t-0 lg:border-l border-border bg-[#FAFBFC] dark:bg-muted/20 flex flex-col min-h-0 w-full lg:w-[min(100%,400px)] max-h-[42vh] lg:max-h-none"
      aria-label="Aperçu de la notification dans le fil HubUP"
    >
      <div className="px-4 py-3 border-b border-border/80 shrink-0">
        <p className="text-xs font-semibold text-foreground">Aperçu dans le fil</p>
        <p className="text-[11px] text-muted-foreground mt-1 leading-relaxed">
          Rendu proche de l’application mobile (texte, médias, formulaire).
        </p>
      </div>
      <div className="flex-1 min-h-0 overflow-y-auto p-4">
        <HubupNotificationFeedCardPreview {...preview} />
      </div>
    </aside>
  );
}
